"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const lodash_1 = __importDefault(require("lodash"));
const shortCode_1 = __importDefault(require("../../libs/shortCode"));
class MerchantApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * 取得餐廳資料
     */
    getMerchant() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 取得餐廳的排序設定
     */
    getSorting() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sorting';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 基本設定 (本機設定)                                */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改用戶介面語言
     * 例如 locales: ['zh', 'en']
     */
    updateClientLocales(locales) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/locales';
            const data = { locales };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改用戶預設介面預設語言
     * 例如 language: 'zh'
     */
    updateClientDefaultLanguage(language) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/defaultclientlanguage';
            const data = { value: language };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改廚房單預設語言
     * 例如 language: 'zh'
     */
    updateBatchPrintLanguage(language) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/batchlocale';
            const data = { locale: language };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改金額進位規則
     */
    updateRounding(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/rounding';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改預設服務費
     */
    updateSurcharge(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/surcharge';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改動態 QRCode 功能 (開啟/關閉)
     */
    updateDynamicQRCodeEnable(dynamic) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrcode';
            const data = { dynamic };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updateEnableIntermediateRounding(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enableintermediaterounding';
            const data = { enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改手動列印 QR (開啟/關閉)
     */
    enableManualPrintQR(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/manualprintqr';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改客戶端語言 用戶喜好
     */
    updateClientLocalePreferBrowser(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/clientlocalepreferbrowser';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改動態 QRCode 列印餐廳Logo
     */
    updateQRCodeLogoEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrcodelogo';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updateQRCodePrintMerchantName(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrcodeprintmerchantname';
            const payload = { value };
            const { data } = yield this.api.axiosGo.post(endpoint, payload);
            return data;
        });
    }
    updateQRCodePrintZeroCustomer(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrcodeprintzerocustomer';
            const payload = { value };
            const { data } = yield this.api.axiosGo.post(endpoint, payload);
            return data;
        });
    }
    updateQRCodePrintPrintAt(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrcodeprintprintat';
            const payload = { value };
            const { data } = yield this.api.axiosGo.post(endpoint, payload);
            return data;
        });
    }
    updateQRCodePrintCreatedAt(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrcodeprintcreatedat';
            const payload = { value };
            const { data } = yield this.api.axiosGo.post(endpoint, payload);
            return data;
        });
    }
    /**
     * 修改動態 QRCode 自訂顯示文字
     */
    updateDynamicQRCodeCustomText(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrcustomtext';
            const data = { value };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改動態 QRCode 不須輸入人數 (開啟/關閉)
     */
    updateDynamicQRCodeDisableCustomerCount(disabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/qrdisablecustomercount';
            const data = { value: disabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改拒絕外賣自取訂單 (開啟/關閉)
     */
    toggleTakeawayDisabled(disabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/takeaway';
            const data = { disabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    toggleDeliveryDisabled(disabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/delivery';
            const data = { disabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改繁忙模式 (開啟/關閉)
     */
    enableBusyMode(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/busymode';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改先付款 (開啟/關閉)
     */
    updatePayFirst(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/payfirst';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改堂食取餐通知 (開啟/關閉)
     */
    updateEnableDineInPickupNotification(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/dineinpickupnotification';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改叫侍應功能 (開啟/關閉)
     */
    updateWaiterEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/waiter';
            const data = { enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改顯示更多座位資訊 (開啟/關閉)
     */
    updateEnableLargerTable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enablelargertable';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改桌位頁面使用分頁按鈕 (開啟/關閉)
     */
    updateEnableTablePaginationButton(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enabletablepaginationbutton';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改展開所有座位資訊 (開啟/關閉)
     */
    unstackSubTables(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/unstacksubtables';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改自取最快取餐時間（分鐘）
     */
    updateTakeawayPickupAfterMinutes(minutes) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/takeawaypickupafter';
            const data = { minutes };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改點餐間隔時間（秒）
     */
    updateBatchInterval(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/batchinterval';
            const data = { value };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改點餐間隔時間（秒）
     */
    updateBatchItemLimit(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/batchitemlimit';
            const data = { value };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改滾動式點餐間隔時間及上限
     */
    updateRollingWindowItemLimit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/rollingwindowitemlimit';
            const data = { interval: params.interval, limit: params.limit };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改自訂推薦文字
     */
    updateRecommendCustomText(text) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/recommendcustomtext';
            const data = { value: text };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改使用首次落單時間計時
     */
    updateOrderCutOffBaseOnFirstBatch(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/ordercutoffbaseonfirstbatch';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改截單分鐘（由第一張單起計）
     */
    updateOrderCutOffMins(mins) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/ordercutoffmins';
            const data = { value: mins };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改截單分鐘（由用餐結束前起計）
     */
    updateOrderDiningDurationMins(mins) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/orderdiningdurationmins';
            const data = { value: mins };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改圖片點餐模式 (開啟/關閉)
     */
    updateOrderPictureMode(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/orderpicturemode';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改啟用餐單編號 (開啟/關閉)
     */
    updateEnableCode(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/code';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 基本設定 (餐廳資訊)                                */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改餐廳的
     * 名稱 (name)
     * 介紹 (desc)
     * 電話 (contact)
     * 地址 (address)
     */
    updateInfo(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/info';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改餐廳圖片
     */
    updateMerchantImage(type, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/image';
            const data = new FormData();
            data.append('type', type);
            data.append('file', file);
            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            const response = yield this.api.axiosNode.post(endpoint, data, config);
            return response.data;
        });
    }
    /**
     * 刪除餐廳圖片
     */
    removeMerchantImage(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/merchant/image/${type}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    /**
     * 修改營業時間設定
     * openings 為 7 天的 array
     * 每天可以設定多個 IMerchantOpeningSetting
     */
    updateOpening(openings) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/opening';
            const data = (0, immer_1.produce)(openings, (draft) => {
                lodash_1.default.forEach(draft, (dayConfigs) => {
                    dayConfigs.forEach((config) => {
                        if (typeof config.surcharge === 'object') {
                            config.surcharge = lodash_1.default.get(config, 'surcharge.percent');
                        }
                    });
                });
                return draft;
            });
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                  菜單設定 (排序)                                 */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改分類排序
     */
    updateCategoryOrder(parentCategoryId, categoryIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sort/category';
            const data = { parentCategoryId, categoryIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    /**
     * 修改分類列印順序
     * /m/merchant/sorting 可以拿到 printCategories
     */
    updateCategoryPrinterOrder(categoryIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sort/print';
            const data = { categoryIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    /**
     * 修改推薦分類的餐點項目排序
     */
    updatePromoteOrder(menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sort/promote';
            const data = { menuIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    /**
     * 修改套餐項目排序
     */
    updateSetOrder(categoryId, setIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sort/set';
            const data = { categoryId, setIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    /**
     * 修改餐點項目排序
     */
    updateMenuOrder(categoryId, menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sort/menu';
            const data = { categoryId, menuIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    /**
     * 修改套餐的步驟項目排序
     */
    updateSetmenuOrder(categoryId, setMenuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sort/setmenu';
            const data = { categoryId, menuIds: setMenuIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    updateCategoryTagOrder(categoryTagIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/sort/categorytag';
            const data = { categoryTagIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                落單設定 (落單版面設定)                               */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改外賣時詢問數量 (開啟/關閉)
     */
    updateTakeawayOpeningPrompt(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/takeawayopeningprompt';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                落單設定 (特別選項設定)                               */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改前綴後綴設定
     */
    updateCustomTag(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/customtag';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                落單設定 (設定狀餐規則)                               */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改狀餐規則
     */
    updateComboRule(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/comborule';
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                  列印設定 (預設)                                 */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改結帳後打印收據 (開啟/關閉)
     */
    updateAutoPrintReceipt(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/autoprintreceipt';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改廚房單列印負責員工 (開啟/關閉)
     */
    enablePrintStaff(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/printstaff';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改收據打印進位差異 (開啟/關閉)
     */
    updateShowRoundingInReceipt(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/showroundinginreceipt';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改收據頁腳自訂文字
     */
    updateFooterCustomText(text) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/footercustomtext';
            const data = { value: text };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改精簡模式列印 (開啟/關閉)
     * @deprecated 目前沒有專案使用
     */
    updateLitePrinting(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/liteprinting';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                    桌位設定                                    */
    //* -------------------------------------------------------------------------- */
    /**
     * 新增枱號群
     */
    createTablegroup(groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/tablegroup';
            const data = { group: groupId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除枱號群
     */
    deleteTablegroup(groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/tablegroup';
            const data = { group: groupId, remove: true };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 新增桌位
     * 或修改桌位的枱號群
     * @deprecated 目前沒有專案使用
     */
    updateTable(tableId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/table';
            const data = { table: tableId, group: groupId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 新增複數桌位
     * 或修改複數桌位的枱號群
     */
    updateTables(tableIds, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/table';
            const data = { tables: tableIds, group: groupId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除桌位
     * @deprecated 目前沒有專案使用
     */
    deleteTable(tableId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/table';
            const data = { table: tableId, remove: true };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除複數桌位
     */
    deleteTables(tableIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/table';
            const data = { tables: tableIds, remove: true };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 更改平面圖
     */
    updateTableGeometry(tableGeometry) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/tablegeometry';
            const data = { tableGeometry };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updateTableCapacity(tableCapacity) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/tablecapacity';
            const data = { tableCapacity };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 結帳設定 (付款設定)                                 */
    //* -------------------------------------------------------------------------- */
    /**
     * 設定一個 payment (新增/修改/刪除)
     * 新增: 如果 key 不存在
     * 刪除: 帶 remove: true
     */
    updatePayment(payment) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/payment';
            const data = {
                key: (_a = payment.key) !== null && _a !== void 0 ? _a : shortCode_1.default.generate(7),
                name: payment.name,
                amount: (_b = payment.amount) !== null && _b !== void 0 ? _b : 0,
                percent: (_c = payment.percent) !== null && _c !== void 0 ? _c : 0,
                remove: (_d = payment.remove) !== null && _d !== void 0 ? _d : false,
                extra: (_e = payment.extra) !== null && _e !== void 0 ? _e : false,
                tips: (_f = payment.tips) !== null && _f !== void 0 ? _f : false,
                gateway: (_g = payment.gateway) !== null && _g !== void 0 ? _g : '',
                merchantId: (_h = payment.merchantId) !== null && _h !== void 0 ? _h : '',
                terminalId: (_j = payment.terminalId) !== null && _j !== void 0 ? _j : '',
                excludeFromIncome: (_k = payment.excludeFromIncome) !== null && _k !== void 0 ? _k : false,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 結帳設定 (枱號群)                                 */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改枱號群的服務費與折扣
     */
    updateTablegroup(groupId, setting) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/merchant/tablegroup/${groupId}`;
            const response = yield this.api.axiosGo.put(endpoint, setting);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 結帳設定 (運送方式)                                */
    //* -------------------------------------------------------------------------- */
    /**
     * 設定一個 shipping (新增/修改/刪除)
     * 新增: 如果 key 不存在
     * 刪除: 帶 remove: true
     */
    updateShipping(shipping) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/shipping';
            const data = {
                key: (_a = shipping.key) !== null && _a !== void 0 ? _a : shortCode_1.default.generate(7),
                name: shipping.name,
                cost: shipping.cost,
                discounts: shipping.discounts,
                enabled: shipping.enabled,
                freightCollect: shipping.freightCollect,
                maxDeliveryMinute: (_b = shipping.maxDeliveryMinute) !== null && _b !== void 0 ? _b : 0,
                minAmount: (_c = shipping.minAmount) !== null && _c !== void 0 ? _c : 0,
                minDeliveryMinute: (_d = shipping.minDeliveryMinute) !== null && _d !== void 0 ? _d : 0,
                remove: (_e = shipping.remove) !== null && _e !== void 0 ? _e : false,
                type: shipping.type,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 結帳邏輯設定                                 */
    //* https://dimorder.atlassian.net/browse/PM-993                               */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改服務費在折扣後計算設定
     */
    updateIsSurchargeBasedOnDiscountedItemTotal(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/issurchargebasedondiscounteditemtotal';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改訂單商品折扣使用折扣後餐點計算設定
     */
    updateIsOrderProductModifierBasedOnDiscountedItemTotal(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/isorderproductmodifierbasedondiscounteditemtotal';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改菜單每次項目限制 (開啟/關閉)
     */
    updateEnableMenuBatchItemLimit(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enablemenubatchitemlimit';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改服務費稅項設定
     */
    updateSurchargeTax(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/surchargetax';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改所有稅項設定
     */
    updateAllTaxSettings(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/taxsettings';
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                     其他                                     */
    //* -------------------------------------------------------------------------- */
    /**
     * 新增支出/收入
     * ! response?
     */
    addCashRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/cash';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 取得支出/收入紀錄
     * ! response?
     */
    listCashRequest(from, to, type, deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/cash';
            const params = { from, to, type };
            if (deviceId) {
                params.deviceId = deviceId;
            }
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 新增開帳/收班結餘
     */
    addCashBalance(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/cash-balance';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 取得結餘記錄列表
     */
    listCashBalance(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/cash-balance';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 更新結餘備註
     */
    updateCashBalanceRemark(id, remark) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/cash-balance/${id}`;
            const response = yield this.api.axiosGo.put(endpoint, { remark });
            return response.data;
        });
    }
    /**
     * 取得目前裝置的結餘狀態（即時計算）
     */
    getCashBalanceCurrent(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/cash-balance/current';
            const params = { deviceId };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    getUiVersion(client) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/s/health/version';
            const data = { client };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * Merchant App 有在使用
     */
    getCustomItems() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/custom';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 取得傳送給 Octopus Mini PC 的 JWT
     */
    getOctopusMiniPCJWT() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/octopus/token';
            const response = yield this.api.axiosGo.post(endpoint);
            return response.data;
        });
    }
    /**
     * 取得會員群組
     */
    getGroup() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/group';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 取得會員列表/搜尋會員
     */
    getGroupUserList(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/group/user';
            const response = yield this.api.axiosGo.get(endpoint, { params: query });
            return response.data;
        });
    }
    /**
     * 取得會員點數紀錄
     */
    getCustomerPointsRecord(userId, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/user/${userId}/point`;
            const response = yield this.api.axiosGo.get(endpoint, { params: query });
            return response.data;
        });
    }
    /**
     * 取得贈品資料
     */
    getMerchantReward(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/reward';
            const response = yield this.api.axiosGo.get(endpoint, { params: query });
            return response.data;
        });
    }
    getGroupUserCount() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/group/usercount';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data.total;
        });
    }
    updateCustomerDisplayDiningTimeEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enablecustomerdysplaydiningtime';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updateCustomerDisplayCutOffTimeEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enablecustomerdysplaycutofftime';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updatePrintDiningTimeEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enableprintdiningtime';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updatePrintCutOffTimeEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/enableprintcutofftime';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    requestEInvoiceBooklet(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/einvoice/booklet';
            const response = yield this.api.axiosGo.post(endpoint, { deviceId });
            return response.data;
        });
    }
}
exports.default = MerchantApi;
//# sourceMappingURL=Merchant.js.map